import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@americanexpress/dls-react';
import { IconChevronRight } from '@americanexpress/dls-icons';
import { useModal } from '@/context/modalContext';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungePrioritisedAccessRules } from '@/hooks/loungesHooks/loungesHelperHooks';
import { usePriorityPassEnrollmentDetails } from '@/hooks/priorityPassHooks/priorityPassHelperHooks';
import { isPriorityPassLounge } from '@/helpers/utils';

const PolicyButton = ({
  id,
  heading,
  modalType,
  icon,
  variant = 'default',
}) => {
  const { setModalName } = useModal();
  const { customTrack } = useAnalyticsContext();
  const { loungeId } = useRouteParams();
  const accessRules = useLoungePrioritisedAccessRules(loungeId);
  const {
    enabled: isPriorityPassEnabled,
    badge: priorityPassBadgeStatus,
    content: priorityPassContent,
  } = usePriorityPassEnrollmentDetails();
  const isPriorityPass =
    isPriorityPassEnabled && isPriorityPassLounge(accessRules);
  const isLegacy = variant === 'legacy';

  return (
    <button
      id={id}
      type="button"
      className={
        isLegacy
          ? 'tw-w-full tw-px-2 tw-py-4 focus_tw-rounded-2xl'
          : 'tw-w-full tw-border-0 tw-px-0 tw-py-5dot5 tw-text-gray-800'
      }
      onClick={(e) => {
        customTrack({
          event: e,
          detail: id,
        });
        setModalName(modalType);
      }}
    >
      <div
        className={
          isLegacy ? 'tw-flex tw-gap-2' : 'tw-flex tw-items-center tw-gap-3'
        }
      >
        {isLegacy ? (
          icon
        ) : (
          <span className="tw-flex tw-h-6 tw-w-6 tw-flex-shrink-0 tw-items-center tw-justify-center svg-children_tw-h-6 svg-children_tw-w-6 svg-children_tw-fill-gray-700">
            {icon}
          </span>
        )}
        <p
          className={
            isLegacy
              ? 'tw-heading-xs-bold'
              : 'tw-font-dls tw-text-base tw-font-normal tw-not-italic tw-leading-6 tw-text-gray-800'
          }
        >
          {heading}
        </p>
        <span className="tw-ml-auto tw-flex tw-items-center tw-gap-2">
          {id.includes('access-policy') && isPriorityPass && (
            <Badge
              className="tw-body-xs-bold"
              status={priorityPassBadgeStatus}
              size="large"
              type="text"
            >
              {priorityPassContent?.title}
            </Badge>
          )}
          <IconChevronRight
            size="sm"
            isFilled={true}
            color={isLegacy ? 'tw-blue-bright-600' : 'brand'}
          />
        </span>
      </div>
    </button>
  );
};

PolicyButton.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  modalType: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  variant: PropTypes.oneOf(['default', 'legacy']),
};

export default PolicyButton;
